// extracted by mini-css-extract-plugin
export default {"bloc":"BfKWU2I0LZCYKdhCmgBL","blocHeader":"t8ISwf4vjkpIk6ugRM_v"};